import mokaRequest from '@/tools/mokaRequest';
import { getI18n } from '@/utils/i18n';

const i18n = getI18n();

export function getApplyFormExtendInfo({
  orgId,
  ids,
}: {
  orgId: string;
  jobId: string;
  ids: number[];
}) {
  return mokaRequest('/api/outer/ats-candidate/apply-form/extend-info/query/headhunters', {
    interceptOnError: true,
    actionName: i18n.t`获取申请表额外信息`,
  }).post({
    orgId,
    ids,
  });
}
